<div class="main_wraper">
  <header class="clearfix">
    <div class="mid_container">
      <div class="mid_container_inner">
        <div class="logo"> <img src="assets/images/logo-aba.png" class="img-responsive" /></div>
      </div>
    </div>

    <div class="nav2 ">
      <div class="mid_container ">
        <div class="mid_container_inner">
          <div class="logo_text">BankExec®
            <div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

  <section>
    <div class="login_wraper">
      <div class="mid_container">
        <div class="login_section">
          <h3 class="right_header"> Forgot Your Password?</h3>
          <p>Enter your Registered Email for this Program to receive your password.</p>
          <form class="form-horizontal" #courseForm="ngForm" (ngSubmit)="ForgotPassword()">
            <div class="form-group">
              <div class="cols-sm-10">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-user fa" aria-hidden="true"></i></span>
                  <input type="text" class="form-control" id="name" placeholder="Enter Email Registered for this Program" [(ngModel)]="email" name="name">
                </div>
              </div>
            </div>
            <div class="form-group ">
              <!-- <a href="Forgot_Password_Submit.html" class="btn btn-primary btn-lg btn-block login-button">Submit</a> -->
                <button class="btn btn-primary btn-lg btn-block login-button check_valid" type="submit">Submit</button>
            </div>
            <div *ngIf="erroremailMsg" class="errormsg">
              {{erroremailMsg}}</div>
          </form>
        </div>
      </div>
    </div>
  </section>
